import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ReactComponent as Alumni } from '../assets/svg/icons/Alumni.svg';
import { ReactComponent as Parent } from '../assets/svg/icons/Parent.svg';
import { ReactComponent as Staff } from '../assets/svg/icons/Staff.svg';
import { ReactComponent as Student } from '../assets/svg/icons/Student.svg';
import { ReactComponent as MessagesIcon } from '../assets/svg/icons/ask-question.svg';
import { ReactComponent as ChevronDown } from '../assets/svg/icons/chevron-down.svg';
import { ReactComponent as Employee } from '../assets/svg/icons/employee-profile.svg';
import { ReactComponent as MapIcon } from '../assets/svg/icons/map-marker-f.svg';
import { ReactComponent as SchoolStudent } from '../assets/svg/icons/school-student.svg';
import { ReactComponent as Logo } from '../assets/svg/logo-2.svg';

import DateHumanizeHelper from '../helpers/DateHumanizeHelper';

import dayjs from 'dayjs';
import { NavLink, useNavigate } from 'react-router-dom';
import { getQueryDataOnSignClick, openChatBlock } from '../helpers/Chat';
import {
    IsMobile,
    getCommonRoutePath,
    getIndividualNamePath,
    getStudentYear,
    getUniversityId,
    isHiddenGroupCarouselUniLogo,
    isUniGroup,
    showFlag,
    isSASCGroupAccount,
} from '../helpers/Helpers';
import isEqualPaths from '../helpers/isEqualPaths';
import { fetchData } from '../redux/actions/randomItems';
import { setSearchTerm } from '../redux/actions/searchActions';
import MixPanelService from '../system/services/MixPanelService';
import ChildrenInfo from './ChildrenInfo';

import { Button, Image, List, Row } from 'antd';
import userDefaultAvatar from '../assets/img/placeholder-user.png';
import universityDefaultAvatar from '../assets/img/university_default_avatar.jpeg';
import { IsLoggedIn } from '../helpers/UserHelper';
import { localStorageWrapper, sessionStorageWrapper } from '../helpers/storageFactory';

import cn from 'classnames';

const isTextClamped = (elm) => elm.scrollHeight > elm.clientHeight;

const TapPageStudentItem = ({
    student,
    searchUsers,
    fromChatToUs,
    university,
    groupUniversityId,
    randomPage,
    onChatToMeClick,
}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const account = useSelector((state) => state.account);
    const { onlyOneScreen } = useSelector((state) => state.main);
    const filterTerms = useSelector((state) => state.filterTerms);
    const searchTerms = useSelector((state) => state.searchTerms);
    const [isClampedText, setIsClampedText] = useState(false);
    const [descriptionToggle, setDescriptionToggle] = useState(false);

    const isSASCGroup = isSASCGroupAccount();

    const isCarousel = window.location.pathname.includes('carousel');

    const descriptionElement = useRef(null);
    useEffect(() => {
        if (descriptionElement.current && isCarousel) {
            setTimeout(() => {
                setIsClampedText(isTextClamped(descriptionElement.current));
            }, 100);
        }
    }, [isCarousel]);

    const handleSearch = useCallback(
        (e, term, educationType) => {
            e.stopPropagation();

            const location = window.location;
            const universityId = getUniversityId();
            const uniGroup = isUniGroup();

            if (account.isAuthFromMobApp) {
                return;
            }

            if (isCarousel) {
                let query = window.location.href.split('?')[1] ? window.location.href.split('?')[1] : '';
                query = '?' + query;
                return navigate(`${getCommonRoutePath()}/chat-to-us/${student.id}${query}`);
            }
            if (educationType) {
                MixPanelService.track('Click on education type filter', {
                    Ambassador: student.name,
                    university_id: student.university_id,
                    Prospect: account.account_info ? 'registered' : 'unregistered',
                    ClickedFilter: term,
                });
            }

            dispatch(setSearchTerm(term));

            if (onlyOneScreen) {
                const options = {
                    search: [...searchTerms.items, term.trim(), ...filterTerms.customFilters].filter((term) => term),
                    filterTerms: filterTerms.preparedFilters,
                    random: false,
                };

                searchUsers(options);
            } else if (
                isEqualPaths(location.pathname, '/' + (uniGroup ? 'group/' + universityId : universityId)) ||
                window.globalUniversityId ||
                window.globalGroupId
            ) {
                const options = {
                    search: [...searchTerms.items, term.trim(), ...filterTerms.customFilters].filter((term) => term),
                    filterTerms: filterTerms.preparedFilters,
                    random: false,
                };

                dispatch(fetchData(options));

                if (window.globalUniversityId || window.globalGroupId) {
                    navigate({
                        pathname: '/',
                        resetContent: true,
                    });
                }
            } else if (uniGroup) {
                navigate({
                    pathname: `${getCommonRoutePath()}`,
                    resetContent: true,
                });
            } else {
                const options = {
                    search: [...searchTerms.items, term.trim(), ...filterTerms.customFilters].filter((term) => term),
                    filterTerms: filterTerms.preparedFilters,
                    random: false,
                };

                if (searchUsers) {
                    searchUsers(options);
                }
            }
        },
        [dispatch, student, navigate]
    );

    const handleChatToMeClick = useCallback(
        (e, openSignUp = false) => {
            e.stopPropagation();
            if (e.button === 2) {
                e.preventDefault();
            }

            if (account.isAuthFromMobApp) {
                const postData = JSON.stringify({ success: true, studentId: student.id });
                if (window.ReactNativeWebView) {
                    window.ReactNativeWebView.postMessage(postData);
                }
                return;
            }

            const isAmbassador =
                account.account_info && account.account_info.id && account.account_info.key === 'univercity-student';
            if (!isAmbassador) {
                sessionStorageWrapper.setItem('goBack', fromChatToUs ? '/chat-to-us' : '');
                localStorageWrapper.setItem(
                    'cameFromData',
                    JSON.stringify({ type: 'profile', from: randomPage ? 'homePage' : 'card' })
                );
                localStorageWrapper.setItem(
                    'openedChatData',
                    JSON.stringify({ type: 'profile', from: 'card', place: fromChatToUs ? 'chatToUs' : 'home' })
                );
            } else {
                e.preventDefault();
                openChatBlock(e.target);
            }
            if (openSignUp) {
                onChatToMeClick(university, student, e.target);
            }
        },
        [account, fromChatToUs, randomPage, university, student, onChatToMeClick]
    );

    const onProfileClick = useCallback(() => {
        if (account.isAuthFromMobApp) {
            return;
        }

        MixPanelService.track('View Profile page from Profile cards', {
            Ambassador: student.name,
            university_id: student.university_id,
            Prospect: account.account_info ? 'registered' : 'unregistered',
        });
        let query = window.location.href.split('?')[1] ? window.location.href.split('?')[1] : '';
        query = query.length ? '?' + query : '';
        navigate(`${getCommonRoutePath()}/chat-to-us/${getIndividualNamePath(student.name, student.id)}/${query}`);
    }, [navigate, student]);

    const toggleDescription = useCallback((e) => {
        e.stopPropagation();
        setDescriptionToggle((prevState) => !prevState);
    }, []);

    const isOnline = student.last_activity
        ? dayjs().valueOf() <= dayjs(student.last_activity).valueOf() + 1000 * 60 * 5
        : false;
    const { additionalData } = student;

    const displayFlag = showFlag();

    let description = null;
    let avatar = null;
    let subject = null;
    let courses = null;
    let interests = null;
    let year = null;
    let job = null;
    let industry = null;
    let staff = null;
    let role = null;
    let roleImg = null;
    let groupUniversity = null;
    let jobTitle = null;
    let companyCountryName = null;
    let companyRegion = null;
    let workingSince = null;

    const isMobile = IsMobile();
    const queryData = getQueryDataOnSignClick();

    if (!student.description) {
        description = ' ';
    } else {
        description = student.description;
    }

    const universityAvatar =
        university && university.avatar && university.avatar.original
            ? university.avatar.sizes['160x160'] || university.avatar.original
            : universityDefaultAvatar;

    if (!student.groupUniversity) groupUniversity = '';
    else groupUniversity = student.groupUniversity.name;

    if (!student.avatar) {
        avatar = student.isUniversity ? universityAvatar : userDefaultAvatar;
    } else {
        if (!student.avatar.sizes['160x160']) {
            avatar = student.avatar.original;
        } else {
            avatar = student.avatar.sizes['160x160'];
        }
    }

    if (!student.user_tags) {
        subject = null;
    } else {
        if (!student.user_tags.subject) {
            subject = null;
        } else {
            subject = student.user_tags.subject[0].name;
        }
    }

    if (!student.user_tags) {
        courses = null;
    } else {
        if (!student.user_tags.courses_types) {
            courses = null;
        } else {
            courses = student.user_tags.courses_types[0].name;
        }
    }

    if (!student.user_tags) {
        jobTitle = null;
    } else {
        if (!student.user_tags.job_title) {
            jobTitle = null;
        } else {
            jobTitle = student.user_tags.job_title[0].name;
        }
    }

    if (!student.user_tags) {
        interests = [];
    } else {
        if (!student.user_tags.interests) {
            interests = [];
        } else {
            interests = student.user_tags.interests.map((tag) => {
                return tag.name;
            });
        }
    }

    if (student.user_tags) {
        if (student.user_tags.job_role) {
            job = student.user_tags.job_role[0].name;
        }
        if (student.user_tags.industry) {
            industry = student.user_tags.industry[0].name;
        }
        if (student.user_tags.staff) {
            staff = student.user_tags.staff[0].name;
        }
    }

    if (!student.user_tags) {
        year = null;
    } else if (student.user_tags.student) {
        year = getStudentYear(student.user_tags);
        if (!year) {
            year = null;
        } else {
            year = year.name;
        }
    }

    if (student.user_tags && student.user_tags.profile && student.user_tags.profile[0]) {
        role = student.user_tags.profile[0].name;
        roleImg =
            role === 'Student' && !(student.user_tags.profile[0].key === 'school_student') ? (
                <Student className="header-info-role-img" />
            ) : role === 'Alumni' ? (
                <Alumni className="header-info-role-img" />
            ) : role === 'Parent' ? (
                <Parent className="header-info-role-img" />
            ) : student.user_tags.profile[0].key === 'school_student' ? (
                <SchoolStudent className="header-info-role-img" />
            ) : student.user_tags.profile[0].key === 'employee' ? (
                <Employee className="header-info-role-img" />
            ) : (
                <Staff className="header-info-role-img" />
            );
    }

    if (additionalData) {
        companyCountryName = additionalData.company_country_name;
        companyRegion = additionalData.company_region;
        workingSince = additionalData.working_since;
    }

    const countryIcon =
        student.user_tags && student.user_tags.countries && displayFlag
            ? student.user_tags.countries[0].code === 'GB-CHA'
                ? 'GB'
                : student.user_tags.countries[0].code
            : null;
    const country = student.user_tags && student.user_tags.countries ? student.user_tags.countries[0].name : null;
    const region = student.region ? student.region : '';
    const showActivity = dayjs(student.last_activity).valueOf() + 3 * 24 * 60 * 60 * 1000 >= dayjs().valueOf();

    const lastActivePlusThree = dayjs(student.last_activity).add(3, 'days');
    const currentDate = dayjs();
    const isActiveRecently = lastActivePlusThree > currentDate;

    const hideCarouselUniLogo = isHiddenGroupCarouselUniLogo();

    return (
        <List.Item className={groupUniversityId ? 'profile-card profile-card-group' : 'profile-card'}>
            {groupUniversityId && !hideCarouselUniLogo && (
                <div className="university-profile-header">
                    <div className="line-left-block">
                        <span className="line-border"></span>
                        <span className="line-border-left"></span>
                    </div>
                    <Image
                        preview={false}
                        src={universityAvatar}
                        onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = universityDefaultAvatar;
                        }}
                        wrapperStyle={{ height: 'auto', display: 'contents' }}
                    />
                    <div className="line-right-block">
                        <span className="line-border"></span>
                        <span className="line-border-right"></span>
                    </div>
                </div>
            )}
            <div
                onClick={() => onProfileClick()}
                className={cn('profile-card-wrapper', {
                    'no-logo': hideCarouselUniLogo,
                })}
                id={`profile-card-${student.id}`}
            >
                <div
                    className={cn('profile-card__header', {
                        'show-logo': isCarousel && isSASCGroup,
                    })}
                >
                    {isCarousel && isSASCGroup && (
                        <div className="powered-tap-logo">
                            <Logo />
                        </div>
                    )}
                    <span className="chat-online">
                        {isOnline ? (
                            <div className="profile-status">
                                <span className="profile-status__dot" />
                                <span className="profile-status__name">Online</span>
                            </div>
                        ) : isActiveRecently ? (
                            showActivity ? (
                                <span>
                                    Last online{' '}
                                    {DateHumanizeHelper(
                                        student.last_activity ? student.last_activity : student.created_at
                                    )}
                                </span>
                            ) : null
                        ) : null}
                    </span>

                    <div className="header-info">
                        {role && (
                            <Button
                                aria-label={`Filter by ${role}`}
                                className="header-info-role"
                                onClick={(e) => handleSearch(e, role)}
                            >
                                <span className="header-info-role-name">{role}</span>
                                {roleImg}
                            </Button>
                        )}
                        {(role === 'Staff' && staff && staff.toLowerCase().indexOf('other') === -1 && (
                            <Button aria-label={`Filter by ${staff}`} className="header-info-sub-info">
                                {staff}
                            </Button>
                        )) ||
                            (role === 'Student' && year && year.toLowerCase().indexOf('other') === -1 && (
                                <Button
                                    aria-label={`Filter by ${year}`}
                                    onClick={(e) => handleSearch(e, year)}
                                    className="header-info-sub-info"
                                >
                                    {year}
                                </Button>
                            )) ||
                            (role === 'Alumni' && industry && (
                                <Button
                                    aria-label={`Filter by ${industry && `${industry}, `}`}
                                    className="header-info-sub-info"
                                >
                                    {industry && `${industry}`}
                                </Button>
                            ))}
                        {workingSince && role === 'Employee' ? (
                            <div className="working_since">since {dayjs(workingSince).format('MMM YYYY')}</div>
                        ) : null}
                    </div>
                </div>
                <div className="chat-img-container">
                    <span
                        onClick={(e) => handleSearch(e, country)}
                        className={
                            countryIcon
                                ? 'flag-icon flag-icon-' +
                                  countryIcon.toLowerCase() +
                                  ' flag-icon-squared chat-img-country'
                                : 'hidden-block'
                        }
                    />
                    <div className="chat-img-block">
                        <Image
                            className="chat-img"
                            src={avatar}
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = userDefaultAvatar;
                            }}
                            alt={student.name + "'s profile picture"}
                        />
                    </div>
                </div>
                <div className="profile-card-text">
                    <Button
                        onClick={() => onProfileClick()}
                        aria-label={`View ${student.name}'s profile`}
                        className="ambassador-profile-link"
                    >
                        <h3 className="chat-item-name">{student.name}</h3>
                    </Button>
                    <Button
                        aria-label={`Filter by ${region}`}
                        onClick={(e) => handleSearch(e, region)}
                        className={role !== 'Employee' && region ? 'chat-item-from' : 'hidden-block'}
                    >
                        {region}
                    </Button>

                    {courses || subject || jobTitle || job ? (
                        <Button
                            className="chat-education-row"
                            aria-label={`Filter by ${courses || subject || jobTitle || job || 'course'}`}
                        >
                            <span className="chat-education-type">
                                {courses && (
                                    <span
                                        className="course-chat-item"
                                        onClick={(e) => handleSearch(e, courses, 'chat-education-type')}
                                    >{`${courses} `}</span>
                                )}
                                {subject && (
                                    <span
                                        className="subject-chat-item"
                                        onClick={(e) => handleSearch(e, subject, 'chat-education-type')}
                                    >
                                        {subject}
                                    </span>
                                )}
                                {jobTitle && (
                                    <span onClick={(e) => handleSearch(e, jobTitle, 'chat-education-type')}>
                                        {jobTitle}
                                    </span>
                                )}
                                {job && <span onClick={(e) => handleSearch(e, job, 'chat-education-type')}>{job}</span>}
                            </span>
                        </Button>
                    ) : null}
                    {role === 'Employee' && additionalData && (
                        <>
                            {/* <div className="company-info-container">
                                        {company_name ? (<div className="company-name">at <span>{company_name}</span></div>) : null}
                                        {working_since ? (<div className="working_since">(since {dayjs(working_since).format("MMM YYYY")})</div>) : null}
                                    </div> */}

                            <div className="company-location-container">
                                {companyRegion || companyCountryName ? <MapIcon className="map-icon" /> : null}
                                {companyCountryName && (
                                    <Button
                                        aria-label={`Filter by ${companyCountryName}`}
                                        onClick={(e) => handleSearch(e, companyCountryName)}
                                        className="chat-item-from company"
                                    >
                                        {companyCountryName},{' '}
                                    </Button>
                                )}
                                {companyRegion && (
                                    <Button
                                        aria-label={`Filter by ${companyRegion}`}
                                        onClick={(e) => handleSearch(e, companyRegion)}
                                        className="chat-item-from company"
                                    >
                                        {companyRegion}
                                    </Button>
                                )}
                            </div>
                        </>
                    )}
                    <p className="chat-item-university">{groupUniversity}</p>
                    {isCarousel ? (
                        <>
                            <p
                                className={cn('chat-item-text', {
                                    'view-more': descriptionToggle,
                                    carousel: isCarousel,
                                })}
                                ref={descriptionElement}
                            >
                                {description}
                            </p>
                            {isClampedText && (
                                <button
                                    onClick={(e) => toggleDescription(e)}
                                    className={cn('chat-item-view-button', {
                                        'view-more': descriptionToggle,
                                    })}
                                >
                                    {!descriptionToggle ? 'View more' : 'View less'}
                                    <ChevronDown />
                                </button>
                            )}
                        </>
                    ) : (
                        <>
                            <p className="chat-item-text">{description}</p>
                        </>
                    )}
                </div>
                <div className="societies-wrapper">
                    {!!interests.length && (
                        <>
                            <span className="chat-societies-name">
                                {role === 'Staff' ? 'Interests' : 'Interests and hobbies'}
                            </span>
                            <Row className="chat-societies-items">
                                {interests.map((interest) => {
                                    const tag = interest;
                                    const tagText = interest;
                                    return (
                                        <Button
                                            className="tag-text"
                                            aria-label={`Filter by ${tagText}`}
                                            onClick={(e) => handleSearch(e, tag)}
                                            key={interest.replace(/\s/, '')}
                                        >
                                            {tagText}
                                        </Button>
                                    );
                                })}
                            </Row>
                        </>
                    )}
                </div>
                <div className="children-wrapper">
                    {student.children && student.children.length > 0 ? (
                        <>
                            <span className="chat-societies-name child">Children at {student.university_name}</span>
                            <ChildrenInfo childrenInfo={student.children} />
                        </>
                    ) : null}
                </div>
                {!IsLoggedIn(account) && !isCarousel && !isMobile ? (
                    <Button
                        className="profile-view-chat-link-button"
                        onClick={(e) => handleChatToMeClick(e, true)}
                        aria-label={`Start a conversation with ${student.name}`}
                    >
                        <span className="profile-view-chat-link-button-text">Ask me a question</span>
                        <MessagesIcon />
                    </Button>
                ) : (
                    <NavLink
                        to={
                            !account.isAuthFromMobApp
                                ? `${getCommonRoutePath()}/interaction/${+student.id + queryData}`
                                : ''
                        }
                        className="profile-view-chat-link-button"
                        style={{ padding: 0 }}
                        id={`chat-link-${student.id}`}
                        onClick={handleChatToMeClick}
                        aria-label={`Start a conversation with ${student.name}`}
                        target={account.isAuthFromMobApp ? '_self' : isMobile ? '_blank' : '_self'}
                    >
                        <span className="profile-view-chat-link-button-text">Ask me a question</span>
                    </NavLink>
                )}
            </div>
        </List.Item>
    );
};

export default TapPageStudentItem;
